module.exports = __webpack_public_path__ + "assets/img/yuyue-girl2.eccea63b.png";